<template>
    <div class="px-7">
        <div v-if="activeAnnouncement && activeAnnouncement?.length">
            <v-alert v-for="ann in activeAnnouncement" :key="ann?.announcement_id" dense outlined 
                class="mb-2" :color="ann.announcement_type_color"
                 :icon="ann.announcement_type_icon">
                <div class="d-flex justify-space-between align-center">
                    <div class="announcement-message">
                        <span>{{ ann?.announcement_desc?.substring(0, 150) }}<span v-if="ann?.announcement_desc?.length > 150">...</span></span>
                        <v-btn x-small text :color="ann.announcement_type_color" @click="onClickViewMore(ann)">
                            View More
                        </v-btn>
                    </div>
                    <div class="grey--text text--darken-1 ml-3">{{ ann?.announcement_date }} (EST) DownTime {{ ann?.duration }}hrs</div>
                </div>
            </v-alert>
        </div>
        <ReadOnlyDialog :dialogHeader="dialogHeader" :commonDialog="commonDialog" @close="onCloseDialog"
            :showTextData="true" :displayArrayData="displayArrayData" :announcementHtml="announcementHtml" />
    </div>
</template>

<script>
import encryptUtility from "../utility/js/encrypt-utility";
import announcementService from "../announcement/js/announcement-service";
import moment from 'moment';
import ReadOnlyDialog from './read-only-dialog.vue';
export default {
    name: "AnnouncementDisplay",
    data() {
        return {
            userId: encryptUtility.localStorageDecrypt("userID"),
            activeAnnouncement: [],
            dialogHeader: 'Announcement Details',
            commonDialog: false,
            displayArrayData: [],
            announcementHtml: '',
            // headerArray: [
            //     {
            //         text: "Ticket Number",
            //         align: "start",
            //         value: "ticket",
            //         class: "primary customwhite--text",
            //     },
            //     {
            //         text: "Page",
            //         align: "start",
            //         value: "page_name",
            //         class: "primary customwhite--text",
            //     },
            //     {
            //         text: "Other Details",
            //         align: "start",
            //         value: "other_details",
            //         class: "primary customwhite--text",
            //     },
            // ],
            // tableItems: [],
        };
    },
    mounted() {
        this.userId?this.getActiveAnnouncement():null;
    },
    methods: {
        async getActiveAnnouncement() {
            let resp = await announcementService.getAnnouncementListData("get", this.userId, "");
            // keep only enabled announcements
            if(resp && resp.length > 0){
                this.activeAnnouncement = (resp || []).filter((x) => x.enabled == true);
                this.activeAnnouncement.forEach((ann) => {
                    ann.announcement_date = moment(ann.announcement_date).format("MM/DD/YYYY HH:mm");
                })
            }          
        },
        async onClickViewMore(announcement) {
            this.commonDialog = true;
            let announcementDetails = await announcementService.getAnnouncementDetails("get", this.userId, announcement?.announcement_id);
            
            this.announcementHtml = announcementDetails.details && announcementDetails.details.length > 0 
                ? announcementDetails.details[0].announcement_html 
                : '';
            
            this.displayArrayData = [
                { label: "Announcement Name", value: announcementDetails.announcement_name },
                { label: "Announcement Description", value: announcementDetails.message_data },
                { label: "Announcement Date", value: moment(announcementDetails.announcement_date).format("MM/DD/YYYY HH:mm") },
                { label: "Downtime (in hrs)", value:announcementDetails.duration.toString() },
                { label: "Contact Name", value: announcementDetails.contact_name },
                { label: "Support Email", value: announcementDetails.support_email },
                { label: "Phone", value: announcementDetails.phone }
            ]

        },
        onCloseDialog() {
            this.commonDialog = false;
        }



    },
    components: {
        ReadOnlyDialog
    }
};
</script>